import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../shared.module';
import { SettingsRoutingModule } from './settings.routing';
import { SettingsPageComponent } from '../pages/settings.component';
import { EditUserPageComponent } from '../pages/edit-user.component';
import { VersionPageComponent } from '../pages/version.component';
import { EditPasswordPageComponent } from '../pages/edit-password.component';
import { TranslationsPageComponent } from '../pages/translations.component';
import { EquipmentsPageComponent } from '../pages/equipments.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, TranslateModule, SettingsRoutingModule],
  declarations: [
    SettingsPageComponent,
    EditUserPageComponent,
    VersionPageComponent,
    EditPasswordPageComponent,
    TranslationsPageComponent,
    EquipmentsPageComponent
  ]
})
export class SettingsModule {}
